import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import NavBar from '../../components/NavBar.jsx';
import Adsense from '../../components/common/Adsense.jsx';
import './Chemistry.css';
import { useTranslation } from 'react-i18next';
import { localize } from '../../i18n/locale';

function ChemistryLoading() {
    const navigate = useNavigate();
    const location = useLocation();
    const { i18n } = useTranslation();
    const language = i18n.resolvedLanguage || i18n.language;
    const tr = (ko, en) => localize(language, { ko, en });
    const [phase, setPhase] = useState(() => tr('안면 랜드마크 스캔 중...', 'Scanning facial landmarks...'));
    const loadingAdSlot = import.meta.env.VITE_ADSENSE_LOADING_SLOT || '0000000000';

    useEffect(() => {
        // We already moved to /result by the API call in Info.jsx, but if they
        // came here directly without waiting for navigation, we show scanning.
        // The actual API call is in Info.jsx, so Loading doesn't need to fetch.
        const steps = language.startsWith('en')
            ? ['Extracting facial landmarks...', 'Calculating axes and absolute distances...', 'Scanning pose-invariant geometry...', 'Encoding the 14-dimensional Z-vector...', 'Synchronizing Geometry DNA...']
            : ['안면 랜드마크 추출 중...', '수평 축과 절대 거리 연산 중...', '포즈 불변 기하학 스캔 중...', '14차원 Z-Vector 인코딩 중...', 'Geometry DNA 동기화 중...'];
        let stepIndex = 0;

        const interval = setInterval(() => {
            stepIndex++;
            if (stepIndex < steps.length) {
                setPhase(steps[stepIndex]);
            }
        }, 1500);

        return () => clearInterval(interval);
    }, [navigate, language]);

    return (
        <div className="layout-wrapper light-theme">
            <NavBar theme="light" />
            <div className="layout-content chemistry-container">
                <div className="ritual-container">
                    <div className="geom-symbol">
                        <svg viewBox="0 0 100 100" className="ritual-svg">
                            {/* Abstract geometry node network animation */}
                            <circle cx="50" cy="50" r="40" fill="none" stroke="#ccc" strokeWidth="0.5" className="orbit" />
                            <polygon points="50,15 85,75 15,75" fill="none" stroke="#FF5A5F" strokeWidth="1" className="tri1" />
                            <polygon points="50,85 15,25 85,25" fill="none" stroke="#36A2EB" strokeWidth="1" className="tri2" />
                            <circle cx="50" cy="15" r="3" fill="#FF5A5F" className="node n1" />
                            <circle cx="85" cy="75" r="3" fill="#FF5A5F" className="node n2" />
                            <circle cx="15" cy="75" r="3" fill="#FF5A5F" className="node n3" />
                            <circle cx="50" cy="85" r="3" fill="#36A2EB" className="node n4" />
                            <circle cx="15" cy="25" r="3" fill="#36A2EB" className="node n5" />
                            <circle cx="85" cy="25" r="3" fill="#36A2EB" className="node n6" />
                        </svg>
                    </div>
                    <h2 className="ritual-text">{phase}</h2>
                    <p className="ritual-subtext">{tr('두 데이터가 공간 상에서 공명하는 황금 거리를 측정 중입니다.', 'Measuring the optimal distance where the two facial datasets resonate.')}</p>
                    <div className="ritual-ad-wrap">
                        <Adsense
                            slot={loadingAdSlot}
                            className="ritual-ad"
                            style={{ display: 'block', width: '100%' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChemistryLoading;
